<template>
    <div class="rc-numeric">
      <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
      <div class="component-content">
        <el-input :class="{onlyread:component.properties.readonly}" disabled>
          <template slot="append" v-if="suffix !== ''">{{suffix}}</template>
        </el-input>
      </div>
    </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-numeric',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  },

  computed: {
    suffix () {
      if (this.component.properties.customSuffix) {
        return this.component.properties.customSuffix
      } else {
        switch (this.component.properties.numType) {
          case 'percentage' :
            return '%'
          case 'year' :
            return '年'
          case 'month' :
            return '月'
          case 'day' :
            return '天'
          default:
            return ''
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .rc-numeric {
    .el-input-group__append {
      width: 36px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/numeric/rc-numeric.vue